import { handleDownloadStaticFile, isMobileQuery } from '../../utils/helpers';
import './index.css'
import PdfIcon from '../../assets/pdf-icon.svg'
import { useState } from 'react';
import { useMediaQuery } from 'react-responsive';

const DownloadSitePdf = () => {
  const [showText, setShowText] = useState(false)
  var [isScrollAtTop, setIsScrollAtTop] = useState(true);
	const isMobile = useMediaQuery(isMobileQuery)
  
  window.addEventListener("scroll", () => {
    if (window.scrollY === 0) {
      setIsScrollAtTop(true);
    } else {
      setIsScrollAtTop(false);
    }
  });
 
  return (
    <div className="site-pdf-wrapper fixed bottom-0 right-0 z-[11] p-[2rem]">
      <a
        onClick={(e) => {
          e.stopPropagation()
          handleDownloadStaticFile({
            path: 'https://flintinfotech.com/profile/Flint-Profile.pdf',
            name: 'Flint Infotech.pdf'
          })
        }}
        id="menu-button"
        aria-expanded="true"
        aria-haspopup="true"
        className={`site-pdf-a ${isScrollAtTop ? '' : 'bottom'} block grow`}
      >
        <div className='flex gap-1 items-center'
          onMouseLeave={() => { setShowText(false) }}

        >
          <div className={`${showText || isMobile ? 'show-text' : ''} site-pdf-text flex items-center  md:justify-end cursor-pointer font-notosans`}
            onMouseEnter={() => { !showText && setShowText(true) }}
          >
            Download Profile
          </div>

          <img
            src={PdfIcon}
            alt="pdf site"
            className='pdf-img w-[1.95rem] h-[1.95rem] sm:w-[2.2rem] sm:h-[2.2rem] cursor-pointer'
            onMouseEnter={() => { setShowText(true) }}
          />
        </div>
      </a>
    </div>
  );
}

export default DownloadSitePdf;